/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';

const UkrainianFlagIconSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1.1em" height="1.1em" id="flag-icons-ua" viewBox="0 0 640 480">
    <g fillRule="evenodd" strokeWidth="1pt">
      <path fill="gold" d="M0 0h640v480H0z"/>
      <path fill="#0057b8" d="M0 0h640v240H0z"/>
    </g>
  </svg>
);

export const UkrainianFlagIcon = (props) => (
  <Icon component={UkrainianFlagIconSvg} {...props} />
);
